module.exports = __webpack_public_path__ + "static/img/aphorism_background.d7b433b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/practice/aphorism_background.jpg
// module id = +RNB
// module chunks = 96